var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageLayoutWrapper',{staticClass:"outline-none",attrs:{"page":"index","content":_vm.homePage}},[_c('RichContent',{staticClass:"main-content",attrs:{"content":_vm.homePage.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }